
export default function ExampleProfile() {
    return (
        <div className="exampleProfile">
            <div className="exampleProfileCard"></div>
            <div className="exampleProfileName">שם משתמש</div>
        </div>
    )
}
